/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AuthLaunchRouteImport } from './routes/auth/launch'
import { Route as AppBankAccountsIndexRouteImport } from './routes/_app/bank-accounts/index'
import { Route as AppBoxesIndexRouteImport } from './routes/_app/boxes/index'
import { Route as AppSettingsTiersRouteImport } from './routes/_app/settings/tiers'
import { Route as AppSettingsTransfersRouteImport } from './routes/_app/settings/transfers'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppTransfersIndexRouteImport } from './routes/_app/transfers/index'
import { Route as AppTransfersIdRouteImport } from './routes/_app/transfers/$id'
import { Route as AppTransfersDraftsRouteImport } from './routes/_app/transfers/drafts'
import { Route as AppTransfersNewRouteImport } from './routes/_app/transfers/new'
import { Route as AppBankAccountsIdLedgerRouteImport } from './routes/_app/bank-accounts/$id.ledger'
import { Route as AppBoxesIdLedgerRouteImport } from './routes/_app/boxes/$id.ledger'
import { Route as AppSettingsGroupsIndexRouteImport } from './routes/_app/settings/groups/index'
import { Route as AppSettingsGroupsIdServicesRouteImport } from './routes/_app/settings/groups/$id.services'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AppBankAccountsIndexRoute = AppBankAccountsIndexRouteImport.update({
  id: '/bank-accounts/',
  path: '/bank-accounts/',
  getParentRoute: () => AppRoute,
} as any)
const AppBoxesIndexRoute = AppBoxesIndexRouteImport.update({
  id: '/boxes/',
  path: '/boxes/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsTiersRoute = AppSettingsTiersRouteImport.update({
  id: '/settings/tiers',
  path: '/settings/tiers',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsTransfersRoute = AppSettingsTransfersRouteImport.update({
  id: '/settings/transfers',
  path: '/settings/transfers',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)
const AppTransfersIndexRoute = AppTransfersIndexRouteImport.update({
  id: '/transfers/',
  path: '/transfers/',
  getParentRoute: () => AppRoute,
} as any)
const AppTransfersIdRoute = AppTransfersIdRouteImport.update({
  id: '/transfers/$id',
  path: '/transfers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppTransfersDraftsRoute = AppTransfersDraftsRouteImport.update({
  id: '/transfers/drafts',
  path: '/transfers/drafts',
  getParentRoute: () => AppRoute,
} as any)
const AppTransfersNewRoute = AppTransfersNewRouteImport.update({
  id: '/transfers/new',
  path: '/transfers/new',
  getParentRoute: () => AppRoute,
} as any)
const AppBankAccountsIdLedgerRoute = AppBankAccountsIdLedgerRouteImport.update({
  id: '/bank-accounts/$id/ledger',
  path: '/bank-accounts/$id/ledger',
  getParentRoute: () => AppRoute,
} as any)
const AppBoxesIdLedgerRoute = AppBoxesIdLedgerRouteImport.update({
  id: '/boxes/$id/ledger',
  path: '/boxes/$id/ledger',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIndexRoute = AppSettingsGroupsIndexRouteImport.update({
  id: '/settings/groups/',
  path: '/settings/groups/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIdServicesRoute =
  AppSettingsGroupsIdServicesRouteImport.update({
    id: '/settings/groups/$id/services',
    path: '/settings/groups/$id/services',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/reports': typeof AppReportsRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/settings/tiers': typeof AppSettingsTiersRoute
  '/settings/transfers': typeof AppSettingsTransfersRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/transfers/$id': typeof AppTransfersIdRoute
  '/transfers/drafts': typeof AppTransfersDraftsRoute
  '/transfers/new': typeof AppTransfersNewRoute
  '/bank-accounts/': typeof AppBankAccountsIndexRoute
  '/boxes/': typeof AppBoxesIndexRoute
  '/transfers/': typeof AppTransfersIndexRoute
  '/bank-accounts/$id/ledger': typeof AppBankAccountsIdLedgerRoute
  '/boxes/$id/ledger': typeof AppBoxesIdLedgerRoute
  '/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesByTo {
  '/reports': typeof AppReportsRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
  '/settings/tiers': typeof AppSettingsTiersRoute
  '/settings/transfers': typeof AppSettingsTransfersRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/transfers/$id': typeof AppTransfersIdRoute
  '/transfers/drafts': typeof AppTransfersDraftsRoute
  '/transfers/new': typeof AppTransfersNewRoute
  '/bank-accounts': typeof AppBankAccountsIndexRoute
  '/boxes': typeof AppBoxesIndexRoute
  '/transfers': typeof AppTransfersIndexRoute
  '/bank-accounts/$id/ledger': typeof AppBankAccountsIdLedgerRoute
  '/boxes/$id/ledger': typeof AppBoxesIdLedgerRoute
  '/settings/groups': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/reports': typeof AppReportsRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/settings/tiers': typeof AppSettingsTiersRoute
  '/_app/settings/transfers': typeof AppSettingsTransfersRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/transfers/$id': typeof AppTransfersIdRoute
  '/_app/transfers/drafts': typeof AppTransfersDraftsRoute
  '/_app/transfers/new': typeof AppTransfersNewRoute
  '/_app/bank-accounts/': typeof AppBankAccountsIndexRoute
  '/_app/boxes/': typeof AppBoxesIndexRoute
  '/_app/transfers/': typeof AppTransfersIndexRoute
  '/_app/bank-accounts/$id/ledger': typeof AppBankAccountsIdLedgerRoute
  '/_app/boxes/$id/ledger': typeof AppBoxesIdLedgerRoute
  '/_app/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/_app/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/reports'
    | '/auth/launch'
    | '/settings/tiers'
    | '/settings/transfers'
    | '/settings/users'
    | '/transfers/$id'
    | '/transfers/drafts'
    | '/transfers/new'
    | '/bank-accounts/'
    | '/boxes/'
    | '/transfers/'
    | '/bank-accounts/$id/ledger'
    | '/boxes/$id/ledger'
    | '/settings/groups/'
    | '/settings/groups/$id/services'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/reports'
    | '/auth/launch'
    | '/'
    | '/settings/tiers'
    | '/settings/transfers'
    | '/settings/users'
    | '/transfers/$id'
    | '/transfers/drafts'
    | '/transfers/new'
    | '/bank-accounts'
    | '/boxes'
    | '/transfers'
    | '/bank-accounts/$id/ledger'
    | '/boxes/$id/ledger'
    | '/settings/groups'
    | '/settings/groups/$id/services'
  id:
    | '__root__'
    | '/_app'
    | '/_app/reports'
    | '/auth/launch'
    | '/_app/'
    | '/_app/settings/tiers'
    | '/_app/settings/transfers'
    | '/_app/settings/users'
    | '/_app/transfers/$id'
    | '/_app/transfers/drafts'
    | '/_app/transfers/new'
    | '/_app/bank-accounts/'
    | '/_app/boxes/'
    | '/_app/transfers/'
    | '/_app/bank-accounts/$id/ledger'
    | '/_app/boxes/$id/ledger'
    | '/_app/settings/groups/'
    | '/_app/settings/groups/$id/services'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/bank-accounts/': {
      id: '/_app/bank-accounts/'
      path: '/bank-accounts'
      fullPath: '/bank-accounts/'
      preLoaderRoute: typeof AppBankAccountsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/boxes/': {
      id: '/_app/boxes/'
      path: '/boxes'
      fullPath: '/boxes/'
      preLoaderRoute: typeof AppBoxesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/tiers': {
      id: '/_app/settings/tiers'
      path: '/settings/tiers'
      fullPath: '/settings/tiers'
      preLoaderRoute: typeof AppSettingsTiersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/transfers': {
      id: '/_app/settings/transfers'
      path: '/settings/transfers'
      fullPath: '/settings/transfers'
      preLoaderRoute: typeof AppSettingsTransfersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transfers/': {
      id: '/_app/transfers/'
      path: '/transfers'
      fullPath: '/transfers/'
      preLoaderRoute: typeof AppTransfersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transfers/$id': {
      id: '/_app/transfers/$id'
      path: '/transfers/$id'
      fullPath: '/transfers/$id'
      preLoaderRoute: typeof AppTransfersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transfers/drafts': {
      id: '/_app/transfers/drafts'
      path: '/transfers/drafts'
      fullPath: '/transfers/drafts'
      preLoaderRoute: typeof AppTransfersDraftsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transfers/new': {
      id: '/_app/transfers/new'
      path: '/transfers/new'
      fullPath: '/transfers/new'
      preLoaderRoute: typeof AppTransfersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bank-accounts/$id/ledger': {
      id: '/_app/bank-accounts/$id/ledger'
      path: '/bank-accounts/$id/ledger'
      fullPath: '/bank-accounts/$id/ledger'
      preLoaderRoute: typeof AppBankAccountsIdLedgerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/boxes/$id/ledger': {
      id: '/_app/boxes/$id/ledger'
      path: '/boxes/$id/ledger'
      fullPath: '/boxes/$id/ledger'
      preLoaderRoute: typeof AppBoxesIdLedgerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/': {
      id: '/_app/settings/groups/'
      path: '/settings/groups'
      fullPath: '/settings/groups/'
      preLoaderRoute: typeof AppSettingsGroupsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/$id/services': {
      id: '/_app/settings/groups/$id/services'
      path: '/settings/groups/$id/services'
      fullPath: '/settings/groups/$id/services'
      preLoaderRoute: typeof AppSettingsGroupsIdServicesRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppReportsRoute: typeof AppReportsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppSettingsTiersRoute: typeof AppSettingsTiersRoute
  AppSettingsTransfersRoute: typeof AppSettingsTransfersRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppTransfersIdRoute: typeof AppTransfersIdRoute
  AppTransfersDraftsRoute: typeof AppTransfersDraftsRoute
  AppTransfersNewRoute: typeof AppTransfersNewRoute
  AppBankAccountsIndexRoute: typeof AppBankAccountsIndexRoute
  AppBoxesIndexRoute: typeof AppBoxesIndexRoute
  AppTransfersIndexRoute: typeof AppTransfersIndexRoute
  AppBankAccountsIdLedgerRoute: typeof AppBankAccountsIdLedgerRoute
  AppBoxesIdLedgerRoute: typeof AppBoxesIdLedgerRoute
  AppSettingsGroupsIndexRoute: typeof AppSettingsGroupsIndexRoute
  AppSettingsGroupsIdServicesRoute: typeof AppSettingsGroupsIdServicesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppReportsRoute: AppReportsRoute,
  AppIndexRoute: AppIndexRoute,
  AppSettingsTiersRoute: AppSettingsTiersRoute,
  AppSettingsTransfersRoute: AppSettingsTransfersRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppTransfersIdRoute: AppTransfersIdRoute,
  AppTransfersDraftsRoute: AppTransfersDraftsRoute,
  AppTransfersNewRoute: AppTransfersNewRoute,
  AppBankAccountsIndexRoute: AppBankAccountsIndexRoute,
  AppBoxesIndexRoute: AppBoxesIndexRoute,
  AppTransfersIndexRoute: AppTransfersIndexRoute,
  AppBankAccountsIdLedgerRoute: AppBankAccountsIdLedgerRoute,
  AppBoxesIdLedgerRoute: AppBoxesIdLedgerRoute,
  AppSettingsGroupsIndexRoute: AppSettingsGroupsIndexRoute,
  AppSettingsGroupsIdServicesRoute: AppSettingsGroupsIdServicesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
